import actions from "./actions";

const initState = {
  insuranceCompanyInfo: {},
  insuranceCompanies: {
    data: [],
    total_count: 0,
  },
  companyDeleted: false,
  loading: false,
};

export default function insuranceCompaniesReducer(state = initState, action) {
  switch (action.type) {
    case actions.FETCH_INSURANCE_COMPANIES_REQUESTED:
      return {
        ...state,
        loading: true,
        companyDeleted: false,
      };
    case actions.FETCH_INSURANCE_COMPANIES_SUCCEEDED:
      return {
        ...state,
        insuranceCompanies: {
          data: action.payload?.data || [],
          total_count: action.payload?.total_count ?? 0,
        },
        loading: false,
      };
    case actions.FETCH_INSURANCE_COMPANIES_FAILED:
      return {
        ...state,
        loading: false,
      };
    case actions.FETCH_INSURANCE_COMPANY_REQUESTED:
      return {
        ...state,
        insuranceCompanyInfo: {},
        loading: true,
      };
    case actions.FETCH_INSURANCE_COMPANY_SUCCEEDED:
      return {
        ...state,
        insuranceCompanyInfo: action.payload || {},
        loading: false,
      };
    case actions.FETCH_INSURANCE_COMPANY_FAILED:
      return {
        ...state,
        loading: false,
      };
    case actions.DELETE_INSURANCE_COMPANY_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case actions.DELETE_INSURANCE_COMPANY_SUCCEEDED:
      return {
        ...state,
        companyDeleted: true,
        loading: false,
      };
    case actions.DELETE_INSURANCE_COMPANY_FAILED:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
}
